var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-switch", {
    attrs: {
      id: _vm.id,
      "data-test-id": "onChange",
      disabled: !_vm.isVisible(null, false) || _vm.disabled,
      "input-value": _vm.value,
      color: _vm.color,
      dark: _vm.dark,
      light: _vm.light,
      loading: _vm.loading,
      "append-icon": _vm.appendIcon,
      "append-icon-cb": _vm.appendIconCb,
      "background-color": _vm.backgroundColor,
      error: _vm.error,
      "error-count": _vm.errorCount,
      "error-messages": _vm.errorMessages,
      "false-value": _vm.falseValue,
      height: _vm.height,
      "hide-details": _vm.hideDetails,
      hint: _vm.hint,
      inset: _vm.inset,
      label: _vm.label,
      messages: _vm.messages,
      multiple: _vm.multiple,
      "persistent-hint": _vm.persistentHint,
      "prepend-icon": _vm.prependIcon,
      "prepend-icon-cb": _vm.prependIconCb,
      readonly: _vm.readonly,
      ripple: _vm.ripple,
      rules: _vm.rules,
      success: _vm.success,
      "success-messages": _vm.successMessages,
      "true-value": _vm.trueValue,
      "validate-on-blur": _vm.validateOnBlur,
      "value-comparator": _vm.valueComparator,
    },
    on: { change: _vm.onChange },
    scopedSlots: _vm._u(
      [
        {
          key: "label",
          fn: function () {
            return [_vm._t("label")]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }